import classNames from "classnames/bind";
import React from "react";
import FontAwesome from "react-fontawesome";
import styles from "./AlertMessage.module.scss";
import { AlertMessageIcon } from "./AlertMessageIcon";
import { AlertMessageProps } from "./types";

const cx = classNames.bind(styles);

/**
 * A wrapper component that shows message below the child component on some trigger
 * @deprecated if needed for input validation messaging, use `InvalidInputMessage` or `InvalidInputMessageTooltip` instead
 */
const AlertMessage = ({
  type,
  simplified = false,
  children,
  onClose,
  style,
}: AlertMessageProps) => {
  return (
    <div
      style={style}
      className={cx(
        "alertMessageContainer",
        simplified
          ? `alertMessageContainer--${type}-simplified`
          : `alertMessageContainer--${type}`
      )}
      role="alert-message"
    >
      <div className={cx("informationContainer")}>
        <div className={cx("icon")}>
          <AlertMessageIcon type={type} />
        </div>

        <div className={cx("text")}>{children}</div>

        {onClose && (
          <button
            aria-label="close"
            className={cx("closeButton")}
            onClick={onClose}
          >
            <FontAwesome name="times fa fa-fw" />
          </button>
        )}
      </div>
    </div>
  );
};

export default AlertMessage;
